<template>
    <div>
        <HeaderPage href="/downloads" />
        <div class="container_wrap">
            <div class="neiBanner">
                <div class="textBanner wow">
                    <dl>NEWS CENTER</dl>
                    <dt>新闻中心</dt>
                </div>
            </div>
            <div class="download">
                <div class="wrap">
                    <div class="box wow">
                        <ul>
                            <li>
                                <a href="http://122.224.62.138:9001/zjgz/纺织企业安全生产标准化评定标准20251025161411.doc"
                                    target="_blank">
                                    <h3>纺织企业安全生产标准化评定标准</h3>
                                    <span>2023-12-18 16:00:06</span>
                                </a>
                            </li>
                            <li>
                                <a href="http://122.224.62.138:9001/zjgz/机械制造企业安全生产标准化规范20251025161347.doc"
                                    target="_blank">
                                    <h3>机械制造企业安全生产标准化规范</h3>
                                    <span>2023-12-29 10:58:05</span>
                                </a>
                            </li>
                            <li>
                                <a href="http://122.224.62.138:9001/zjgz/机械制造企业安全生产标准化评定标准20251025161307.doc"
                                    target="_blank">
                                    <h3>机械制造企业安全生产标准化评定标准</h3>
                                    <span>2023-12-29 10:58:25</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <FooterPage />
    </div>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue';

// 组件逻辑
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'

let intervalId


const stopAutoScroll = () => {
    clearInterval(intervalId)
}

onMounted(() => {

    // ✅ 滚动动画逻辑
    const elements = document.querySelectorAll('.wow')
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const el = entry.target
                const animateName = el.dataset.animate || 'fadeInUp'
                if (entry.isIntersecting) {
                    el.classList.add('animated', animateName)
                    // ✅ 添加后立即取消观察，避免重复触发
                    observer.unobserve(el)
                }
            })
        },
        { threshold: 0.2 }
    )
    elements.forEach((el) => observer.observe(el))
    onUnmounted(() => {
        elements.forEach((el) => observer.unobserve(el))
        stopAutoScroll()
    })
})
</script>

<style scoped>
.download .box ul{
    width: 100%
}
.neiBanner {
    height: 500px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background: url('@/assets/images/bg/aiOiaD.jpg');
}

.neiBanner .textBanner {
    color: #fff;
    text-align: center;
}

.neiBanner .textBanner dl {
    font-size: 42px;
}

.neiBanner .textBanner dt {
    font-size: 30px;
}

.service.indexFour {
    padding: 80px 0 150px;
    background: none;
}

.wrap {
    width: 1680px;
    margin: 0 auto;
}

.flex {
    display: flex;
    width: 100%;
}

.ntitle {
    text-align: center;
    margin-bottom: 50px;
}

.ntitle h3 {
    font-size: 38px;
    line-height: 1;
    color: #003366;
    font-weight: 500;
    border-bottom: #003366 solid 1px;
    display: inline-block;
    padding: 0 0 15px;
    margin-bottom: 15px;
}

.ntitle h2 {
    font-size: 36px;
    line-height: 1;
    color: #333;
    font-weight: 500;
}

.indexFour .box {
    padding: 20px 30px 0;
}

.indexFour .box ul li {
    width: 33.33%;
    padding: 0 30px;
    list-style: none;
}

.indexFour .item {
    height: 100%;
    padding: 0 45px 45px;
    background: #f5f5f5;
    transition: all 0.4s;
}

.indexFour .item i {
    width: 110px;
    height: 110px;
    line-height: 110px;
    text-align: center;
    background: #00437c;
    display: block;
}

.indexFour .item h3 {
    font-size: 36px;
    border-bottom: #a88333 solid 2px;
    padding: 20px;
    margin-bottom: 30px;
}

.indexFour .item .text {
    font-size: 18px;
}

.indexFour .item .text p {
    margin-bottom: 13px;
}

.indexFour .item .text p::before {
    content: "▪";
    font-size: 14px;
    margin-right: 15px;
}
</style>